import { combineReducers } from '@reduxjs/toolkit';
import authSlice from './auth/auth-slice';
import bankAccountSlice from './bank-account/bank-account-all-slice';
import bankAllSlice from './bank/bank-all-slice';
import bankEditSlice from './bank/bank-edit-slice';
import bankPaginatedSlice from './bank/bank-paginated-slice';
import campaignEditSlice from './campaigns/campaign-edit-slice';
import campaignSlice from './campaigns/campaigns-all-slice';
import campaignsPaginatedSlice from './campaigns/campaigns-paginated-slice';
import corporateEditSlice from './corporates/corporate-edit-slice';
import corporatesAllSlice from './corporates/corporates-all-slice';
import corporatesPaginatedSlice from './corporates/corporates-paginated-slice';
import filesListSlice from './files-list/files-slice';
import plickDetailSlice from './plick-detail/plick-detail-slice';
import plicksSlice from './plicks-list/plicks-slice';
import statisticsSlice from './statistics/statistics-slice';
import userEditSlice from './user/user-edit-slice';
import userPaginatedSlice from './user/user-paginated-slice';

const rootReducer = combineReducers({
    auth: authSlice,
    bankAccountUser: bankAccountSlice,
    bankEdit: bankEditSlice,
    banksPaginated: bankPaginatedSlice,
    banksUser: bankAllSlice,
    campaignEdit: campaignEditSlice,
    campaignsUser: campaignSlice,
    campaignsPaginated: campaignsPaginatedSlice,
    corporateEdit: corporateEditSlice,
    corporatesPaginated: corporatesPaginatedSlice,
    corporatesUser: corporatesAllSlice,
    files: filesListSlice,
    plicks: plicksSlice,
    plickDetail: plickDetailSlice,
    statistics: statisticsSlice,
    users: userPaginatedSlice,
    userEdit: userEditSlice
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
